import { resolveCurrencySymbol } from './resolve-currency-symbol.js';
/**
 * Compact variant of {@link formatCurrency}: rounds to whole units, no
 * decimals. Used for tight spaces like bar-graph labels where "R12,400"
 * reads better than "R12,400.00".
 *
 * A negative amount reads `-R1,234`, matching formatCurrency.
 *
 * Returns '-' when minorUnits is null. Currency defaults to 'ZAR' when
 * null or undefined (the platform's default currency).
 */
export function formatCurrencyCompact(minorUnits, currency) {
    if (minorUnits === null)
        return '-';
    const amount = minorUnits / 100;
    const symbol = resolveCurrencySymbol(currency ?? 'ZAR');
    const rounded = Math.round(Math.abs(amount));
    const formatted = rounded.toLocaleString('en-GB', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    // Sign before the symbol, as formatCurrency writes it; an amount that rounds to zero carries none.
    const sign = amount < 0 && rounded !== 0 ? '-' : '';
    return `${sign}${symbol}${formatted}`;
}
